/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */

const NATIONAL_NUMBER_LENGTH = 10;
const COUNTRY_CODE = '1';

const toNationalDigits = (value: string): string => {
  const digits = value.replace(/\D/g, '');

  const isE164 =
    value.trimStart().startsWith('+') &&
    digits.length === NATIONAL_NUMBER_LENGTH + 1 &&
    digits.startsWith(COUNTRY_CODE);

  return (isE164 ? digits.slice(1) : digits).substring(0, NATIONAL_NUMBER_LENGTH);
};

export const phoneNumberFormatter = (value: string): string => {
  const cleaned = toNationalDigits(value);

  let formattedNumber = '';

  if (cleaned.length > 0) {
    formattedNumber += `(${cleaned.substring(0, 3)}`;
  }
  if (cleaned.length >= 4) {
    formattedNumber += `) ${cleaned.substring(3, 6)}`;
  }
  if (cleaned.length >= 7) {
    formattedNumber += `-${cleaned.substring(6, 10)}`;
  }

  return formattedNumber;
};

export const toE164PhoneNumber = (value: string): string => {
  const national = toNationalDigits(value);

  return national.length === NATIONAL_NUMBER_LENGTH ? `+${COUNTRY_CODE}${national}` : '';
};
